import { createSlice } from "@reduxjs/toolkit";

const initialPharmacyReturnsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  ordersUpdated: false,
  lastError: null
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const pharmacyReturnsSlice = createSlice({
  name: "pharmacyReturns",
  initialState: initialPharmacyReturnsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.entities = [];
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    pharmacyReturnsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    pharmacyReturnAccepted: (state) => {
      state.actionsLoading = false;
      state.ordersUpdated = !state.ordersUpdated;
      state.error = null;
    }
  }
});
